const DownloadReport = ({ downloadReport, translationMap, card = false, classbutton = "button2" }) => {
  return (
    <>
            <div className={`downloadReportMr ${classbutton}`} onClick={(e) => downloadReport(e, card)}>
                <div className="content">
          <span className="button-text">
            {translationMap?.download}
          </span>
                    <i className="fa-solid fa-download"></i>
                </div>
            </div>
        </>);

};

export default DownloadReport;